import React from 'react'
import Space from './InputElements/Box';

import { dashboard_url, protected_api_call } from '../api/api'

class Summary extends React.Component {

    state = {
        "patients": '#',
        "scheduled": '#',
        "unscheduled": '#',
        "voicemail": '#',
        "onboarded_today": '#',
        "onboarded_week": '#',
        "onboarded_month": '#',
        "loading": false,
        "loading_l": false,
        "criticality": "None",
        "insurance": "None",
        "doctor": "None",
        "hospital": "None"
    }

    componentDidMount = async () => {
        this.setState({
            "loading": true
        })
        let response = await protected_api_call(dashboard_url, {}, "GET");
        let data = await response.json();
        data = data["data"]
        this.setState({
            "patients": data["patient"]["total_patients"],
            "scheduled": data["patient"]["patients_scheduled"],
            "unscheduled": data["patient"]["patients_not_scheduled"],
            "voicemail": data["patient"]["patients_voicemail"],
            "onboarded_today": data["onboard"]["onboard_today"],
            "onboarded_week": data["onboard"]["onboard_this_week"],
            "onboarded_month": data["onboard"]["onboard_this_month"],
            "loading": false
        })
    }

    render(){
      let filter_data = {
        "doctor": this.state.doctor,
        "hospital": this.state.hospital,
        "insurance": this.state.insurance,
        "criticality": this.state.criticality
      }
      return(
        <div className='h-[60vh] flex-col'>

            <div className='flex-grow flex flex-col w-full mt-5 pr-10'>
                <div className='flex flex-grow justify-between w-full'>
                    <div className=' w-full flex justify-between'>
                        <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                            Dashboard
                        </h1>
                    </div>

                    <div className='mr-5 w-1/3'>
                        <div className='flex flex-col p-2 border border-gray-600 rounded'>
                            <h1 className='text-purplegray-900 mb-2'>Criticality</h1>
                            <select
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                value={this.state.criticality}
                                onChange = {e => this.setState({criticality: e.target.value})} >
                                {["None", "Critical", "Not critical"].map((option, key) => (
                                    <option key={key} value={option}>{option}</option>
                                ))}
                            </select>
                      </div>        
                    </div>

                    <div className='mr-5 w-1/3'>
                        <div className='flex flex-col p-2 border border-gray-600 rounded'>
                            <h1 className='text-purplegray-900 mb-2'>Insurance</h1>
                            <select
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                value={this.state.insurance}
                                onChange = {e => this.setState({insurance: e.target.value})}>
                                {["None", "Aetna", "Aetna MA", "Medicare", "UHC", "UHC MA", "BCBS", "BCBS MA", "Devoted", "Humana", "Humana MA", "Cigna", "Cigna MA", "Cigna Allegiance", "Tricare", "Veterans Adminstration", "Superior/Ambetter", "Market place plan", "Other"].map((option, key) => (
                                    <option key={key} value={option}>{option}</option>
                                ))}
                            </select>
                      </div>        
                    </div>

                    <div className='mr-5 w-1/3'>
                        <div className='flex flex-col p-2 border border-gray-600 rounded'>
                            <h1 className='text-purplegray-900 mb-2'>Doctor</h1>
                            <select
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                value={this.state.doctor}
                                onChange = {e => this.setState({doctor: e.target.value})}>
                                {["None", "Dr Gandra", "Dr Vuppali", "Dr Patel", "Dr Khaja"].map((option, key) => (
                                    <option key={key} value={option}>{option}</option>
                                ))}
                            </select>
                      </div>        
                    </div>

                    <div className='mr-5 w-1/3'>
                        <div className='flex flex-col p-2 border border-gray-600 rounded'>
                            <h1 className='text-purplegray-900 mb-2'>Hospital</h1>
                            <select
                                className='bg-purple-200 text-gray-700 appearance-none py-2 px-3 border rounded focus:bg-purple-50 focus:border-gray-400 focus:shadow-outline focus:outline-none'
                                value={this.state.hospital}
                                onChange = {e => this.setState({hospital: e.target.value})}>
                                {["None", "Methodist-TW", "Hermann", "Lukes", "NorthWest", "Conroe", "Other-NP", "Other-External"].map((option, key) => (
                                    <option key={key} value={option}>{option}</option>
                                ))}
                            </select>
                      </div>        
                    </div>
                </div>
            </div>

            <div className='flex justify-center items-center flex-col w-full mt-2 rounded'>
                <div className='flex flex-col justify-center items-center w-full'>
                    <div className='flex justify-around bg-purple-600 text-white w-full items-center m-2 p-3'>
                        <span className='text-xl font-bold' ># Patients: {this.state.patients}</span>
                        <span className='text-xl font-bold' ># Patients Scheduled: {this.state.scheduled}</span>
                        <span className='text-xl font-bold' ># Patients UnScheduled: {this.state.unscheduled}</span>
                        <span className='text-xl font-bold' ># Patients Voicemail: {this.state.voicemail}</span>
                    </div>

                    <div className='flex justify-around bg-purple-100 text-purple w-full items-center m-1 p-2'>
                        <span className='text-xl font-bold' ># Onboarded today: {this.state.onboarded_today}</span>
                        <span className='text-xl font-bold' ># Onboarded this week: {this.state.onboarded_week}</span>
                        <span className='text-xl font-bold' ># Onboarded this month: {this.state.onboarded_month}</span>
                    </div>
                </div>
            </div>

            <div className='flex-grow flex flex-col w-full h-full mt-5'>
                <div className='flex flex-grow justify-between w-full h-full'>
                    <Space title="Scheduled Today" type="today" url="/scheduled_today" filter_data={filter_data}/>
                    <Space title="Scheduled This Week" type="week" url="/scheduled_this_week" filter_data={filter_data}/>
                    <Space title="Scheduled Next Week" type="nweek"url="/scheduled_next_week" filter_data={filter_data}/>
                </div>
            </div>

        </div>
      )
    }



}


export default Summary